export default "__VITE_ASSET__BzXn_4nw__"